<template>

  <div>

    <b-sidebar
      id="add-new-user-sidebar"
      v-model="isEdittrainingCategoryDataSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      width="800px"
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-add-new-product-sidebar-active', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            {{ $t('Eğitim Kategorisi') }}
          </h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />

        </div>

        <!-- BODY -->
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(saveData)"
            @reset.prevent="resetForm"
          >

            <!-- Cihaz seri no -->
            <validation-provider
              #default="validationContext"
              :name="$t('Kategori Adı')"
              rules="required|min:2"
            >
              <b-form-group
                :label="$t('Kategori Adı')"
                label-for="m_serial_number"
              >
                <b-form-input
                  id="m_serial_number"
                  v-model="trainingCategoryData.name"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <b-form-group
              v-if="usersData"
              :label="$t('Eğitimi Alması Gereken Kullanıcılar')"
              label-for="users"
            >
              <b-row>
                <b-col md="7">
                  <v-select
                    id="users"
                    v-model="trainingCategoryData.users"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    :options="usersData"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="users"
                  />
                </b-col>
                <b-col md="5">

                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    size="sm"
                    @click="selectAllUsers(true)"
                  >
                    <feather-icon
                      icon="HomeIcon"
                      class="mr-50"
                    />
                    <span class="align-middle">{{ $t('Tümünü Seç') }}</span>
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    size="sm"
                    @click="selectAllUsers(false)"
                  >
                    <feather-icon
                      icon="HomeIcon"
                      class="mr-50"
                    />
                    <span class="align-middle">{{ $t('Seçimleri Kaldır') }}</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-form-group>
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                {{ $t('Kaydet') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                {{ $t('Vazgeç') }}
              </b-button>
            </div>

          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
    <!-- Filters -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>{{ $t('Show') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('Entries') }}</label>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          />
          <!-- Search -->
          <b-col
            cols="12"
            md="4"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-if="false"
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="addData"
              >
                <span class="text-nowrap">{{ $t('Eğitim Kategorisi Oluştur') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refTrainingCategoryListTable"
        class="position-relative"
        :items="fetchTrainingCategories"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        small
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="editData(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Düzenle') }} </span>
            </b-dropdown-item>
            <b-dropdown-item

              variant="danger"
              @click="deleteData(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">{{ $t('Sil') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('Gösterilen') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{ $t('Entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totaltrainingCategoryData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BDropdown, BDropdownItem, BPagination, BSidebar, BFormGroup, BFormInvalidFeedback, BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useTrainingCategoryList from './useTrainingCategoryList'
import trainingStoreModule from '../trainingStoreModule'

export default {
  components: {
    BCard,

    BRow,
    vSelect,
    BCol,

    BSidebar,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    'trainingCategoryData.customer_manager_id': function (newVal, oldVal) {
      this.customerManagerOptions.forEach(val => {
        if (newVal === val.id) {
          this.trainingCategoryData.customer_manager_name = val.name
          this.trainingCategoryData.customer_manager_surname = val.surname
          this.trainingCategoryData.customer_manager_email = val.email
        }
      })
    },

  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    deleteData(id) {
      this.$swal({
        title: this.$t('Emin Misiniz ?'),
        text: this.$t('Eğitim Kategorisini Silmek İstediğinizden Emin Misiniz ? (Bu işlem geri alınamaz.)'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Silme İşlemini Onayla'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-training/deleteTrainingCategory', { id })
            .then(() => {
              this.$refs.refTrainingCategoryListTable.refresh()
              this.showSuccessMessage()
            })
            .catch(() => {
              this.showErrorMessage()
            })
        }
      })
    },
    selectAllUsers(select = false) {
      this.mailData.selected_user_customers = []
      if (select) {
        this.usersData.forEach(val => {
          this.mailData.selected_user_customers.push(val.value)
        })
      }
    },
    showSuccessMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarılı'), {
        title: this.$t('İşlem Başarılı'),
        variant: 'success',
        solid: false,
      })
    },
    showErrorMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarısız'), {
        title: this.$t('İşlem Başarısız'),
        variant: 'danger',
        solid: false,
      })
    },
    saveData() {
      if (this.trainingCategoryData.id === 0) {
        store.dispatch('app-training/addTrainingCategory', this.trainingCategoryData)
          .then(() => {
            this.$refs.refTrainingCategoryListTable.refresh()
            this.isEdittrainingCategoryDataSidebarActive = false
            this.showSuccessMessage()
          })
      } else {
        store.dispatch('app-training/updateTrainingCategory', this.trainingCategoryData)
          .then(() => {
            this.$refs.refTrainingCategoryListTable.refresh()
            this.isEdittrainingCategoryDataSidebarActive = false
            this.showSuccessMessage()
          })
      }
    },
    editData(item) {
      this.trainingCategoryData = JSON.parse(JSON.stringify(item))
      this.isEdittrainingCategoryDataSidebarActive = true
    },
    addData() {
      this.resettrainingCategoryData()
      this.isEdittrainingCategoryDataSidebarActive = true
    },
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-training'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, trainingStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })
    const edittrainingCategoryDataId = ref(0)
    const usersData = ref(null)
    store
      .dispatch('app/fetchUsers', {
        list_type: 'all',
      })
      .then(response => {
        const { users } = response.data.data
        const arr = []
        users.forEach(val => {
          arr.push({ label: `${val.name} (${val.email})`, value: val.id })
        })

        usersData.value = arr
      })
      .catch(() => {
      })
    const isEdittrainingCategoryDataSidebarActive = ref(false)
    const trainingCategoryData = ref(null)
    const temporaryCustomerData = ref(null)
    const blankTemporaryCompanyData = {
      name: '',
      manager_name: '',
      manager_surname: '',
      manager_email: '',
    }
    const transactionOptions = [
      { value: 1, title: 'Onarım', icon: '' },
      { value: 2, title: 'Bakım', icon: '' },
      { value: 0, title: 'Diğer', icon: '' },
    ]
    const statusOptions = [
      { value: 1, title: 'İşleme Alındı', color: 'info' },
      { value: 2, title: 'Onaylandı', color: 'success' },
      { value: 3, title: 'Ücret Onayı', color: 'warning' },
      { value: 0, title: 'Tamamlandı', color: 'secondary' },

    ]
    const blanktrainingCategoryData = {
      id: 0,
      name: '',
      users: '',
    }

    const {
      fetchTrainingCategories,
      tableColumns,
      perPage,
      currentPage,
      totaltrainingCategoryData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTrainingCategoryListTable,
      refetchData,

      // UI

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useTrainingCategoryList()
    const resetTemporaryCustomerData = () => {
      temporaryCustomerData.value = JSON.parse(JSON.stringify(blankTemporaryCompanyData))
    }
    resetTemporaryCustomerData()
    const resettrainingCategoryData = () => {
      trainingCategoryData.value = JSON.parse(JSON.stringify(blanktrainingCategoryData))
    }
    resettrainingCategoryData()
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resettrainingCategoryData)
    return {

      // Sidebar
      isEdittrainingCategoryDataSidebarActive,
      fetchTrainingCategories,
      tableColumns,
      temporaryCustomerData,
      resetTemporaryCustomerData,
      perPage,
      transactionOptions,
      currentPage,
      totaltrainingCategoryData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      refFormObserver,
      trainingCategoryData,
      resettrainingCategoryData,
      getValidationState,
      resetForm,
      edittrainingCategoryDataId,
      isSortDirDesc,
      refTrainingCategoryListTable,
      refetchData,
      usersData,
      statusOptions,
      // Filter
      avatarText,

      // UI
      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      blanktrainingCategoryData,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
